import Card from "antd/es/card/Card";
import { Select } from "antd";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import Spin from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.SCREEN_STUDIO);
  const LIST = t("LIST", { returnObjects: true });
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({ skip: 0, take: 25 });
  const [search, setSearch] = useState("");
  const [processFilter, setProcessFilter] = useState(null);
  const [publishedFilter, setPublishedFilter] = useState("all");

  const publishedOptions = [
    { value: "all", label: LIST.FILTER_ALL },
    { value: "published", label: LIST.FILTER_PUBLISHED },
    { value: "unpublished", label: LIST.FILTER_UNPUBLISHED },
  ];

  const { data: processData } = useQuery(graphql.queries.PROCESSES, {
    variables: { take: 100, orderBy: [{ name: "ASC" }] },
  });
  const processes = processData?.processes?.data || [];

  const where = {};
  if (processFilter) where.process = { id: processFilter };

  const like = isEmpty(search)
    ? undefined
    : { OR: [{ status: { name: `%${search}%` } }] };

  const { data, loading } = useQuery(graphql.queries.SCREENS, {
    variables: {
      ...pagination,
      where: Object.keys(where).length > 0 ? where : undefined,
      like,
      orderBy: [{ createdDate: "DESC" }],
    },
    fetchPolicy: "network-only",
  });

  const allScreens = data?.screens?.data || [];
  const filteredScreens = publishedFilter === "all"
    ? allScreens
    : publishedFilter === "published"
    ? allScreens.filter((s) => s.currentPublishedVersion)
    : allScreens.filter((s) => !s.currentPublishedVersion);

  const resetPagination = () => setPagination((prev) => ({ ...prev, skip: 0 }));

  return (
    <>
      <Header
        title={LIST.HEADER.TITLE}
        actions={[
          {
            text: LIST.HEADER.SAVE,
            onClick: () => navigate(SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.CREATE.path),
            type: "primary",
          },
        ]}
      />
      <Card type="simple">
        <div className="m-bottom-20 d-flex gap-12 flex--wrap">
          <Input
            placeholder={LIST.SEARCH}
            type="search"
            className="screen-studio__search"
            onChange={({ target: { value } }) => {
              resetPagination();
              setSearch(value);
            }}
          />
          <Select
            placeholder={LIST.PROCESS_FILTER}
            value={processFilter}
            onChange={(value) => { resetPagination(); setProcessFilter(value); }}
            allowClear
            onClear={() => { resetPagination(); setProcessFilter(null); }}
            className="screen-studio__process-filter"
            showSearch
            filterOption={(input, option) =>
              (option?.label || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            options={processes.map((p) => ({ value: p.id, label: p.name }))}
          />
          <Select
            value={publishedFilter}
            onChange={(value) => { resetPagination(); setPublishedFilter(value); }}
            className="screen-studio__published-filter"
            options={publishedOptions}
          />
        </div>
        {loading ? (
          <Spin />
        ) : (
          <View
            data={filteredScreens}
            count={publishedFilter === "all" ? (data?.screens?.count || 0) : filteredScreens.length}
            setValues={setPagination}
            skip={pagination.skip}
            list={LIST}
          />
        )}
      </Card>
    </>
  );
};

export default List;
